import { getScrollY } from '../helpers/utilify';

/**
 * @typedef ClickToScrollIntoViewOptions
 * @property {number} offsetY
 */

class ClickToScrollIntoView {
  /**
   * @param {HTMLElement} elm
   * @returns {number}
   */
  static getY (elm) {
    if (!elm) return 0;

    const elmY = elm.getBoundingClientRect().top;
    const scrollY = getScrollY();
    return elmY + scrollY;
  }

  /**
   * @param {string} triggerSelector
   * @param {ClickToScrollIntoViewOptions} options
   * @returns {void}
   */
  constructor (triggerSelector, options = { offsetY: 0 }) {
    this.offsetY = options.offsetY;
    this.triggers = document.querySelectorAll(triggerSelector);

    this.bindClick();
  }

  /**
   * @param {number} offsetY
   * @returns {void}
   */
  setOffsetY (offsetY) {
    this.offsetY = offsetY;
  }

  /**
   * @returns {void}
   */
  bindClick () {
    if (this.onClick_ || !this.triggers) return;

    this.onClick_ = (e) => {
      e.preventDefault();
      this.onClick(e.currentTarget);
    };

    this.triggers.forEach((target) => {
      target.addEventListener('click', this.onClick_, false);
    });
  }

  /**
   * @param {HTMLElement} trigger
   * @returns {void}
   */
  onClick (trigger) {
    const targetSelector = trigger.hash;
    if (!targetSelector) return;

    const target = document.getElementById(targetSelector.substring(1));
    if (!target) return;

    const top = this.constructor.getY(target) - this.offsetY;
    const left = 0;

    window.scrollTo({ top, left, behavior: 'smooth' });
  }

  /**
   * @returns {void}
   */
  bindOffClick () {
    if (!this.onClick_ || !this.triggers) return;

    this.triggers.forEach((target) => {
      target.removeEventListener('click', this.onClick_);
    });

    this.onClick_ = null;
  }
}

export default ClickToScrollIntoView;
